import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isLightMode = theme.palette.type === Theme.Light;
    return {
        root: {
            '& *': {
                zIndex: 2,
            },
        },
        hero: {
            minHeight: 600,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 1,
            [theme.breakpoints.down('xs')]: {
                minHeight: 500,
            },
        },
        dots: {
            position: 'absolute',
            left: 0,
            top: 80,
            zIndex: 1,
            width: '300px !important',
            height: '300px !important',
            '& g': {
                fill: isLightMode ? 'rgb(238,238,238)' : 'rgb(35,35,35)',
            },
            [theme.breakpoints.down('xs')]: {
                display: 'none',
            },
        },
        heroImage: {
            display: 'flex',
            height: '80%',
            maxWidth: 400,
            borderRadius: 50,
            borderBottomRightRadius: 0,
            overflow: 'hidden',
            marginLeft: theme.spacing(8),
            boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.1)',
            pointerEvents: 'none',
            '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            },
            [theme.breakpoints.down(770)]: {
                display: 'none',
            },
        },
        heroText: {
            ...theme.typography.h1,
            marginBottom: theme.spacing(3),
            fontWeight: 700,
            fontSize: '2.75rem',
            [theme.breakpoints.down('xs')]: {
                fontSize: '2.25rem',
            },
            '& span': {
                color: theme.palette.primary.main,
            },
        },
        search: {
            backgroundColor: isLightMode ? 'rgb(255,255,255)' : 'rgb(44, 44, 44)',
            display: 'flex',
            boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.1)',
            borderRadius: 50,
            padding: theme.spacing(0.75),
            marginTop: theme.spacing(3),
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(0.25),
            },
        },
        searchButton: {
            height: '100%',
            boxShadow: 'none !important',
            borderRadius: 50,
            textTransform: 'none',
            minWidth: 150,
            fontSize: '1.175rem',
            fontWeight: 600,
        },
        input: {
            '& fieldset': {
                display: 'none',
            },
            '& input': {
                fontSize: 16,
            },
        },
        statistics: {
            marginTop: '45px',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            '& li': {
                flex: 'auto',
                flexGrow: 0,
                padding: theme.spacing(3),
                minWidth: 128,
            },
            '& strong': {
                display: 'block',
                margin: 0,
                padding: 0,
                fontWeight: 600,
                color: isLightMode ? '#333' : '#fff',
                fontSize: '26px',
                marginBottom: '2px',
                [theme.breakpoints.down('xs')]: {
                    fontSize: '22px',
                },
            },
            '& span': {
                display: 'block',
                margin: 0,
                padding: 0,
                fontWeight: 400,
                color: '#888',
                fontSize: '16px',
                [theme.breakpoints.down('xs')]: {
                    fontSize: '14px',
                },
            },
            '& li:first-child': {
                paddingLeft: 0,
            },
            '& li:last-child': {
                paddingRight: 0,
                textAlign: 'right',
            },
            [theme.breakpoints.down('sm')]: {
                '& li': {
                    marginRight: '15px',
                    paddingRight: '15px',
                    minWidth: '30%',
                },
                '& li:last-child': {
                    marginRight: 0,
                },
            },
            [theme.breakpoints.down(400)]: {
                '& li': {
                    padding: theme.spacing(1),
                },
            },
        },
        verticalDivider: {
            height: 50,
        },
        categories: {
            padding: theme.spacing(4, 0),
            backgroundColor: isLightMode ? 'rgb(252,252,252)' : 'rgb(38,38,38)',
        },
        jobs: {
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(4, 0),
            alignItems: 'center',
            '& .MuiCard-root': {
                boxShadow: '0px 0px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                    cursor: 'pointer',
                    boxShadow: '0px 0px 4px rgba(0,0,0,0.2)',
                },
            },
        },
        categoriesWrapper: {
            display: 'flex',
            justifyContent: 'center',
            [theme.breakpoints.up('md')]: {
                minHeight: '184px',
            },
        },
        headline: {
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            alignItems: 'center',
            marginBottom: theme.spacing(4),
            '& h3': {
                fontSize: '26px',
                lineHeight: '36px',
                fontWeight: 500,
                margin: 0,
            },
        },
        seeMore: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px',
            marginTop: theme.spacing(4),
            '& .MuiButton-root': {
                borderRadius: 20,
                textTransform: 'none',
                padding: theme.spacing(1, 2),
            },
        },
        spinner: {
            height: 180,
        },
    };
});
